import agb from './agb'
import apofinder from './apofinder'
import cartLoadingBar from './cart-loading-bar'
import carousel from './carousel'
import chat from './chat'
import checkout from './checkout'
import checkoutUserStep from './checkout-user-step'
import contactForm from './contact-form'
import contactFormPharmacy from './contact-form-pharmacy'
import coupon from './coupon'
import dashboardItem from './dashboard-item'
import deliveryAddress from './delivery-address'
import deliveryConditions from './delivery-conditions'
import epaper from './epaper'
import error from './404-page'
import footer from './footer'
import forgottenPassword from './forgotten-password'
import form from './form'
import header from './header'
import homepage from './homepage'
import inquiry from './inquiry'
import keyword from './keyword'
import login from './login'
import meta from './meta'
import modal from './modal'
import myAccount from './my-account'
import newsletter from './newsletter'
import notification from './notification'
import orderingProcess from './ordering-process'
import paymentAddress from './payment-address'
import pharmacyBlock from './pharmacy-block'
import pharmacySwitch from './pharmacy-switch'
import prescription from './prescription'
import prescriptionUpload from './prescription-upload'
import product from './product'
import productDetails from './product-details'
import productSearch from './product-search'
import productSearchBar from './product-search-bar'
import register from './register'
import setPassword from './set-password'
import signup from './signup'
import unauthorized from './unauthorized'
import unverifiedUser from './unverified-user'
import userPopup from './user-popup'
import vaccineBooking from './vaccine-booking'
import whatsApp from './whatsapp'

export default {
  agb,
  apofinder,
  cartLoadingBar,
  carousel,
  chat,
  checkout,
  checkoutUserStep,
  contactForm,
  contactFormPharmacy,
  coupon,
  dashboardItem,
  deliveryAddress,
  deliveryConditions,
  epaper,
  error,
  footer,
  forgottenPassword,
  form,
  header,
  homepage,
  inquiry,
  keyword,
  login,
  meta,
  modal,
  myAccount,
  newsletter,
  notification,
  orderingProcess,
  paymentAddress,
  pharmacyBlock,
  pharmacySwitch,
  prescription,
  prescriptionUpload,
  product,
  productDetails,
  productSearch,
  productSearchBar,
  register,
  setPassword,
  signup,
  unauthorized,
  unverifiedUser,
  userPopup,
  vaccineBooking,
  whatsApp,
}
